import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {GetAnalyticsDashboard} from 'insights/analytics-dashboards/details/graphql/__generated/GetAnalyticsDashboard';
import {MAX_DASHBOARD_BLOCKS, MAX_DASHBOARD_BLOCKS_MESSAGE} from 'insights/InsightsConstants';
import Option from 'ui-library/menus/Option';

type AnalyticsDashboard = ExtractByTypename<
  GetAnalyticsDashboard['analyticsDashboard'],
  'AnalyticsDashboardNode'
>;

interface Actions {
  cloneBlock: () => void;
}

interface Props {
  actions: Actions;
  dashboardAttrs: Pick<AnalyticsDashboard, 'analyticsQueries'>;
}

export default function getCloneBlockOption(props: Props): JSX.Element {
  const hasMaxBlocks = props.dashboardAttrs.analyticsQueries.length >= MAX_DASHBOARD_BLOCKS;

  return (
    <Option
      icon="copy"
      isDisabled={hasMaxBlocks}
      onSelect={props.actions.cloneBlock}
      tooltipTitle={hasMaxBlocks ? MAX_DASHBOARD_BLOCKS_MESSAGE : undefined}
    >
      Duplicate
    </Option>
  );
}
